import { UID } from 'shared/api/query/constants';
import { azureDevOpsQuery as azureDevOpsQueryConfig, dataSource as dataSourceConfig, goal as goalConfig } from 'shared/api/query/configs.json';

export const azureDevOpsQueryChildren = [
  { attr: UID },
  {
    attr: azureDevOpsQueryConfig.edges.dataSource,
    model: dataSourceConfig.model,
    default: null,
    children: [{ attr: UID }],
  },
  {
    attr: azureDevOpsQueryConfig.edges.goal,
    model: goalConfig.model,
    children: [{ attr: UID }],
  },
  { attr: azureDevOpsQueryConfig.edges.alwaysSync, default: false },
  { attr: azureDevOpsQueryConfig.edges.error, default: null },
];
